//region :: Imports ::
import {ReactElement} from 'react';
import {evalulateBool, MBoolean} from './Control';
import MComponent from '../Component';
import {MultiSelect, MultiSelectChangeParams} from 'primereact/multiselect';
import {MDropDownItem} from './DropDownOption';
import {FieldProps} from 'formik';
import MDropDown from './DropDown';
import {setFieldValue} from '../../Utils';

//endregion

/** */
type Props<TValue> = {
    id: string;
    items: MDropDownItem<TValue>[];
    initialValues?: TValue[];
    selectionLimit?: number;
    showFilter?: boolean;
    useChips?: boolean;
    placeholderText?: string;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (newValues: TValue[]) => void;
}

/** */
type State<TValue> = {
    values: TValue[];
}

/** */
class MMultiDropDown<TValue> extends MComponent<Props<TValue>, State<TValue>> {

    /** */
    public constructor(props: Props<TValue>) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {
        this.dropDown_OnChange = this.dropDown_OnChange.bind(this);
    }

    /** */
    private initializeState(): void {

        this.state = {values: this.props.initialValues === undefined ? [] : this.props.initialValues};
        setFieldValue(this.props.fieldProps, this.state.values);

    }

    /** */
    private dropDown_OnChange(params: MultiSelectChangeParams): void {
        this.setValue(params.value === null ? [] : params.value);
    }

    /** */
    public setValue(newValues: TValue[]): void {

        this.safeSetState((draft: State<TValue>) => draft.values = newValues);
        setFieldValue(this.props.fieldProps, newValues);
        this.props.onChange?.(newValues);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props<TValue>>, prevState: Readonly<State<TValue>>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State<TValue>) =>
                draft.values = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <MultiSelect id={this.props.id}
                         optionLabel="label"
                         optionValue="value"
                         options={this.props.items}
                         filter={this.props.showFilter}
                         placeholder={this.props.placeholderText}
                         selectionLimit={this.props.selectionLimit}
                         itemTemplate={MDropDown.getOptionTemplate}
                         showClear={true}
                         display={this.props.useChips === undefined || !this.props.useChips ? 'comma' : 'chip'}
                         disabled={evalulateBool(this.props.disabled)}
                         className={this.props.className}
                         {
                             ...this.props.fieldProps?.field
                         }
                         value={this.state.values}
                         onChange={this.dropDown_OnChange}/>
        );

    }

}

export default MMultiDropDown;
